export default __webpack_public_path__ + "static/smart360-3a7862902324e0a69dc5a49ab73b3c85.png";